import { isNull } from 'lodash';

export default (appointment) => {
  const recurrence = {
    repeat_event: isNull(appointment.repeat_event?.value)
      ? null
      : Number(appointment.repeat_event?.value),
    repeat_every:
      appointment.repeat_event?.value && appointment.type !== 'only'
        ? appointment.repeat_every
        : null,
    weekdays:
      appointment.repeat_event?.value &&
      !['Month', 'Year'].includes(appointment?.repeat_event?.name)
        ? JSON.stringify(appointment.weekdays.map((item) => item?.value))
        : [],
    repeat_on: appointment.repeat_on,
    ends_type:
      appointment.repeat_event?.value && appointment.type !== 'only'
        ? appointment.ends_type?.value
        : null,
    events:
      appointment.repeat_event?.value && appointment.type !== 'only' ? appointment.events : null,
    ...(appointment.end_date && {
      end_date: appointment.end_date
    })
  };

  return recurrence;
};
